import React from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import * as Sentry from '@sentry/browser';

import Kurzy from './kurzy'; 
//import Ubytovani from './ubytovani'; 

class Skoly extends React.Component {
    render() {
        if(!Object.keys(this.props.mesto.skoly).length) return null; 
        return (
            <div>
                {this.props.mesto.skoly.map((item, key) => {
                    return (
                        <div className="clear" key={key} style={{marginBottom: 10}}>
                            <div className="skola-container1">
                                <div className="formRow skola">
                                    <label>Škola:</label> 
                                    <select name={`prihlaska[zeme][${this.props.zemeKey}][mesto][${this.props.mestoKey}][skola][${key}][value]`} value={item.value} onChange={(e) => {item.value = e.target.value}} required>
                                        <option value="">-- Zvolte školu --</option> 
                                        {Object.keys(this.state.skoly).map((skolaIndex, skolaKey) => {
                                            let skola = this.state.skoly[skolaIndex];
                                            return <option key={skolaKey} value={skolaIndex}>{skola}</option> 
                                        })}
                                    </select>
                                </div>
                                {item.value !== "" &&
                                    <Kurzy {...this.props} skola={item} skolaKey={key} />
                                }
                            </div>
                            {/*item !== "" &&
                                <Ubytovani idSkoly={item} idMesta={this.props.idMesta} setUbytovani={this.props.setUbytovani} />
                            */}
                            
                        </div>
                    );
                })}
                {/*<div className="formRow more" style={{marginTop: -10}}>
                    <label></label> 
                    <a href="#" onClick={this._add}>+ Zvolit další školu</a>
                </div>*/}
            </div>
        );
    }

    constructor(props) {
        super(props);

        this.state = {
            idMesta: null,
            skoly: {},
        }
    }

    componentDidMount() {
        this._loadskoly(this.props.mesto.value);
    }

    componentWillReceiveProps(newProps) {
        this._loadskoly(newProps.mesto.value);
    }

    _loadskoly = (idMesta) => {
        if(idMesta === this.state.idMesta) return;
        this.setState({
            idMesta: idMesta,
            skoly: {},
        });
        axios.get(this.props.store.apiUrl, {params: {seznam: "skoly", idMesta: idMesta}})
            .then((response) => {
                this.setState({
                    skoly: response.data
                });
            })
            .catch((error) => {
                Sentry.captureException(error);
                alert("Došlo k neočekáváné chybě(#A6) při načítání škol. Prosím kontaktujte nás přímo.")
            });
    }

}

export default Skoly;


// WEBPACK FOOTER //
// ./resources/prihlaska/skoly.js